import { IAppState } from 'shared/common/state';

export const detectedLocationReducer = (state: IAppState): IAppState => {
  return {
    ...state,
    detectedLocation: state.detectedLocation,
  };
};
